import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoAlertsGetRes } from "./abst/DtoAlertsGetRes";

export class DtoAlertsGetResImple extends DtoAlertsGetRes {
  public pager = new DtoApiPager();
}
